var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D6470",
    d: "M10.23.55A1.88 1.88 0 0 0 8.91 0h-6.1a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h1.88v-1.25H2.81c-.69 0-1.25-.56-1.25-1.25v-15c0-.69.56-1.25 1.25-1.25h5v4.38c0 1.04.84 1.88 1.88 1.88h4.38v4.38h1.25V6.41c0-.5-.2-.97-.55-1.32zm-.54 5.7c-.34 0-.62-.28-.62-.62V1.27c.11.03.21.08.29.16l4.53 4.53c.08.08.14.18.16.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.43 13.75H7.18c-.34 0-.62.28-.62.62v5c0 .34.28.62.62.62s.62-.28.62-.62v-1.25h.62a2.19 2.19 0 1 0 0-4.38zm0 3.13h-.62V15h.62a.939.939 0 1 1 0 1.88M13.43 13.75h-1.25c-.34 0-.62.28-.62.62v5c0 .34.28.62.62.62h1.25c1.04 0 1.88-.84 1.88-1.88v-2.5c0-1.04-.84-1.88-1.88-1.88zm.63 4.37c0 .34-.28.62-.62.62h-.62v-3.75h.62c.34 0 .62.28.62.62v2.51M19.06 16.25h-1.25V15h1.25c.34 0 .62-.28.62-.62s-.28-.62-.62-.62h-1.88c-.34 0-.62.28-.62.62v5c0 .34.28.62.62.62s.62-.28.62-.62V17.5h1.25c.34 0 .62-.28.62-.62s-.28-.62-.62-.62z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.31 0h19.38v20H.31z"
  })))));
};
export default SvgPdf;